import styled from "styled-components";

export const SocialMediaCardStyled = styled.div`
  width: 100%;
  max-width: 372px;
  margin: 0 auto;
  overflow: hidden;
  border-radius: 16px;
  display: flex;
  justify-content: center;

  .fb-post {
    width: 100%;
    max-width: 350px;
    display: flex;
    justify-content: center;
  }

  iframe {
    width: 350px;
    height: 461px;
    display: block;
    border-radius: 16px;
    border: 5px solid red;
  }

  @media (max-width: 400px) {
    iframe {
      max-width: 100%;
      height: auto;
    }
  }
`;
